import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  CommissioningStatus,
  CommissioningStatusEnum,
  SupplyAppointmentPartDayStatusEnum,
  SupplyAppointmentStatusEnum
} from '@bo-client/activation-management/shared/models/commissioningModel';
import { Validators } from '@angular/forms';
import { MetaService } from '@bo-client/core/api/meta-service';

@Component({
  selector: 'app-appoinment-agree-modal',
  templateUrl: './appointment-agree-modal.component.html',
  styleUrls: ['./appointment-agree-modal.component.scss']
})
export class AppointmentAgreeModalComponent implements OnInit {
  public isError = false;
  private iniDate: string;
  private iniTime: string;
  public commissioningStatusEnum = CommissioningStatusEnum;
  public changeSupplyAppointment = false;

  constructor(
    public dialogRef: MatDialogRef<AppointmentAgreeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public inputData: any,
    public metaService: MetaService
  ) {}

  ngOnInit(): void {
    this.iniDate = this.inputData.inputForm.get('date').value;
    this.iniTime = this.inputData.inputForm.get('time').value;
  }

  changeData() {
    if (
      this.iniDate != this.inputData.inputForm.get('date').value ||
      this.iniTime != this.inputData.inputForm.get('time').value
    ) {
      this.changeSupplyAppointment = true;
    } else {
      this.changeSupplyAppointment = false;
    }
  }

  confirm() {
    this.checkErrors();
    if (!this.isError) {
      this.dialogRef.close(true);
    }
  }

  cancel() {
    this.inputData.inputForm.get('date').patchValue(this.iniDate);
    this.inputData.inputForm.get('time').patchValue(this.iniTime);
    this.dialogRef.close(false);
    this.isError = false;
  }

  checkErrors() {
    this.inputData.inputForm.get('date').setValidators([Validators.required]);
    this.inputData.inputForm.get('time').setValidators([Validators.required]);
    this.isError =
      !this.inputData.inputForm.get('date').value ||
      !this.inputData.inputForm.get('time').value ||
      this.inputData.inputForm.get('time').value == '';
  }
}
